import React from "react";
import PropTypes from "prop-types";
import WorkareaView from "features/workarea/components/WorkareaView";

export default class RequireWorkarea extends React.Component {
  static propTypes = {
    workarea: PropTypes.string,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node
    ]).isRequired
  };

  static defaultProps = {
    workarea: undefined
  };

  render() {
    if (this.props.workarea) return <div>{this.props.children}</div>;
    return <WorkareaView {...this.props} />;
  }
}
